import apiClient, {timeouts} from 'shared/services/apiClient';
import {SuccessResponse} from "shared/types/common";
import {endpoints} from "shared/services/endpoints";
import {
    CreateCategoryResp,
    GetCategoriesResp, GetCategoryAttributesResp,
    GetCategoryPhrasesResp,
    PerformStepForCategoryResp, TestPhraseResp,
    ValidationRulesSearchStatus
} from "../types";

export const validationRulesService = {
    getCategories: async () => {
        return apiClient
            .get<GetCategoriesResp>(endpoints.categories.list, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as GetCategoriesResp)
            .catch((reason) => {
                return {curr_categories: [], errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as GetCategoriesResp;
            }
        );
    },

    createCategory: async (cat_num: number) => {
        return apiClient
            .post<CreateCategoryResp>(endpoints.categories.list, {cat_num}, {timeout: timeouts.mediumOperationsTimeout})
            .then(r => r.data as CreateCategoryResp)
            .catch((reason) => {
                return {success: false, message: "", errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as CreateCategoryResp;
            }
        );
    },

    performStepForCategory: async (cat_id: number) => {
        return apiClient
            .post<PerformStepForCategoryResp>(endpoints.categories.byId(cat_id), {}, {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as PerformStepForCategoryResp)
            .catch((reason) => {
                return {success: false, status: ValidationRulesSearchStatus.ErrorOccured, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as PerformStepForCategoryResp;
            }
        );
    },

    fetchCategoryStatus: async (cat_id: number) => {
        return apiClient
            .get<PerformStepForCategoryResp>(endpoints.categories.status(cat_id), {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as PerformStepForCategoryResp)
            .catch((reason) => {
                return {success: false, status: ValidationRulesSearchStatus.ErrorOccured, long_running: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as PerformStepForCategoryResp;
            }
        );
    },

    restartCategory: async (cat_id: number) => {
        return apiClient
            .put<PerformStepForCategoryResp>(endpoints.categories.byId(cat_id), {}, {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as PerformStepForCategoryResp)
            .catch((reason) => {
                return {success: false, status: ValidationRulesSearchStatus.ErrorOccured, long_running: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as PerformStepForCategoryResp;
            }
        );
    },

    getCategoryPhrases: async (cat_id: number) => {
        return apiClient
            .get<GetCategoryPhrasesResp>(endpoints.categories.phrases(cat_id), {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as GetCategoryPhrasesResp)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as GetCategoryPhrasesResp;
            }
        );
    },

    getCategoryAttributes: async (cat_id: number) => {
        return apiClient
            .get<GetCategoryAttributesResp>(endpoints.categories.attributes(cat_id), {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as GetCategoryAttributesResp)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as GetCategoryAttributesResp;
            }
        );
    },

    testCategoryPhrase: async (cat_id: number, phrase: string) => {
        return apiClient
            .post<TestPhraseResp>(endpoints.categories.phrases(cat_id), {phrase}, {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as TestPhraseResp)
            .catch((reason) => {
                return {success: false, message: "Unknown error occured!", errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as TestPhraseResp;
            }
        );
    },

    deleteCategory: async (cat_id: number) => {
        return apiClient
            .delete<SuccessResponse>(endpoints.categories.byId(cat_id), {timeout: timeouts.complexOperationsTimeout})
            .then(r => r.data as SuccessResponse)
            .catch((reason) => {
                return {success: false, errorCode: reason.response !== undefined? reason.response.status : reason.request.status } as SuccessResponse;
            }
        );
    }
};
